import { Redirect, Route, Switch, useLocation } from 'wouter';
import { useMe } from './lib/hooks';
import { Shell } from './components/layout';
import { LoginPage } from './pages/login';
import { DashboardPage } from './pages/dashboard';
import { TasksPage } from './pages/tasks';
import { NotesPage } from './pages/notes';
import { AreasPage } from './pages/areas';
import { WorkspacesPage } from './pages/workspaces';
import { SettingsPage } from './pages/settings';
import { ShoppingPage } from './pages/shopping';

export function App() {
  const me = useMe();
  const [location] = useLocation();

  if (me.isLoading) {
    return <div className="flex h-full items-center justify-center text-slate-500">…</div>;
  }

  if (!me.data) {
    if (location !== '/login') return <Redirect to="/login" />;
    return <LoginPage />;
  }

  if (location === '/login') return <Redirect to="/" />;

  return (
    <Shell>
      <Switch>
        <Route path="/" component={DashboardPage} />
        <Route path="/tasks" component={TasksPage} />
        <Route path="/notes" component={NotesPage} />
        <Route path="/areas" component={AreasPage} />
        <Route path="/workspaces" component={WorkspacesPage} />
        <Route path="/shopping" component={ShoppingPage} />
        <Route path="/settings" component={SettingsPage} />
        <Route>
          <div className="p-6 text-slate-500">404 — Không tìm thấy trang</div>
        </Route>
      </Switch>
    </Shell>
  );
}
